import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from './en'
import zhLocale from './zh'

// 引入本地包
const messages = {
  zh: {
    ...zhLocale,
    ...elementZhLocale,
  },
  en: {
    ...enLocale,
    ...elementEnLocale,
  },
}

export default messages
